export const latestNotificationsLimit = 3;
